// 2. Pages/ForgotPasswordPage.vue
<template>
  <div class="min-h-screen flex items-center justify-center bg-gradient-to-br from-blue-50 to-indigo-100">
    <div class="max-w-md w-full space-y-8 p-8 bg-white rounded-xl shadow-lg">
      <div class="text-center">
        <h2 class="text-3xl font-bold text-gray-900 mb-2">Mot de passe oublié</h2>
        <p class="text-gray-600">
          Entrez votre email pour recevoir un lien de réinitialisation
        </p>
      </div>
      
      <div v-if="!emailSent">
        <form @submit.prevent="handleForgotPassword" class="space-y-6">
          <div>
            <label for="email" class="block text-sm font-medium text-gray-700 mb-2">
              Adresse email
            </label>
            <InputText
              id="email"
              v-model="email"
              type="email"
              placeholder="votre@email.com"
              class="w-full"
              :class="{ 'p-invalid': errors.email }"
              required
            />
            <small v-if="errors.email" class="p-error">{{ errors.email }}</small>
          </div>
          
          <Button
            type="submit"
            label="Envoyer le lien"
            class="w-full"
            :loading="loading"
          />
        </form>
      </div>
      
      <div v-else class="text-center space-y-4">
        <div class="p-4 bg-green-50 rounded-lg">
          <i class="pi pi-check-circle text-green-600 text-2xl mb-2"></i>
          <p class="text-green-800 font-medium">Email envoyé !</p>
          <p class="text-green-600 text-sm">
            Vérifiez votre boîte mail pour le lien de réinitialisation
          </p>
        </div>
        
        <Button
          @click="emailSent = false"
          label="Renvoyer l'email"
          class="w-full"
          severity="secondary"
        />
      </div>
      
      <div class="text-center">
        <router-link 
          to="/" 
          class="text-sm text-blue-600 hover:text-blue-500"
        >
          Retour à la connexion
        </router-link>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref } from 'vue'

const email = ref('')
const loading = ref(false)
const emailSent = ref(false)
const errors = ref({})

const handleForgotPassword = async () => {
  errors.value = {}
  
  if (!email.value) {
    errors.value.email = 'Email requis'
    return
  }
  
  loading.value = true
  
  try {
    // Simulation d'envoi d'email
    await new Promise(resolve => setTimeout(resolve, 1500))
    emailSent.value = true
  } catch (error) {
    errors.value.general = 'Erreur lors de l\'envoi'
  } finally {
    loading.value = false
  }
}
</script>
